import { IMobileTableScema } from '../../../../helpers/formatters';
import TableCardMobile, {
  ITableCard,
} from '../../../../molecules/Table/mobile/TableCard';
import TableHeaderMobile from '../../../../molecules/Table/mobile/TableHeader';

import './styles.scss';

interface IBodyTableMobileProps {
  data: ITableCard[];
  schema: IMobileTableScema;
}

const BodyTableMobile = ({ data, schema }: IBodyTableMobileProps) => {
  return (
    <div className='mobile_modal_body_table'>
      <TableHeaderMobile schema={schema} />
      {data.map((row, index) => (
        <TableCardMobile key={index} data={row} />
      ))}
    </div>
  );
};

export default BodyTableMobile;
